export { default } from './Dealer';
